import React from "react";
import Container from "../../Layout/Container";
import SectionTitle from "../../SectionTitle";

const TableContent = ({ data, className = "py-0", addContainer = true }) => {
  const { title, table } = data || {};

  if (!title || !table?.length) return null;

  const Component = addContainer ? Container : React.Fragment;
  const props = addContainer ? { className } : {};

  return (
    <Component {...props}>
      {title && (
        <SectionTitle
          title={title}
          color={"secondary"}
          weight="bold"
          className={"mb-8 text-center"}
        />
      )}
      {table?.length > 0 && (
        <div className="overflow-x-auto">
          <table className="mx-auto w-full max-w-[800px] table-fixed border-collapse text-left">
            <thead>
              <tr>
                <th className="w-1/2 border border-white bg-primary px-6 py-3 text-center font-openSans text-lg text-white md:text-xl">
                  Persons without diabetes
                </th>
                <th className="w-1/2 border border-white bg-primary px-6 py-3 text-center font-openSans text-lg text-white md:text-xl">
                  Persons with diabetes
                </th>
              </tr>
            </thead>
            <tbody>
              {table.map((item, index) => (
                <tr
                  key={index}
                  className={
                    index + (1 % 2) === 0 ? "bg-[#C3C3C31A]" : "bg-[#C3C3C326]"
                  }
                >
                  <td className="font-futuraL border border-white px-6 py-4 text-center text-lg md:text-xl ">
                    {item.personsWithoutDiabetes}
                  </td>
                  <td className="border border-l-0 border-white px-6 py-4 text-center font-openSans text-lg md:text-xl">
                    {item.personsWithDiabetes}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Component>
  );
};

export default TableContent;
